<template>
  <div class="_feed_item__note">
    <md-card :id="note.id" :key="note.id" class="message-viewport note">
      <DeepLink :id="note.id" />
      <md-card-content>
        <div class="email-form">
          <div class="_noteCard">
            <div class="_noteCard__header">
              <md-avatar class="_noteCard__avatar">
                <img src="/img/default-avatar.png" alt="Avatar" />
              </md-avatar>
              <div class="_noteCard__title">
                <md-icon class="_noteCard__type">note</md-icon>
                <span
                  class="_noteCard__author"
                  v-if="note.user"
                >{{note.user.given_name}} {{note.user.family_name}}</span>
                <span class="_noteCard__time">
                  <md-icon v-if="note.internal">lock</md-icon>
                  <md-icon>schedule</md-icon>
                  {{ timediff(note.createdAt) }}
                </span>
              </div>
            </div>
            <div class="control-btn _noteCard__actions">
              <span @click="editNote()">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">edit</i>
              </span>
              <span v-if="$Session.isAdminGroupMember" @click="deleteNoteAlert()">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">delete</i>
              </span>
              <span class="md-sm md-primary" @click="comment()" v-if="showCommentButton()">
                <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">comment</i>
              </span>
            </div>
            <div class="_noteCard__body">
              <!-- <p><strong>Added a note</strong></p> -->
              <div v-html="note.note" v-linkified></div>
              <div class="md-layout-item md-layout-item-attachment md-layout-item-padding" v-if="note.attachment">
                <template v-for="(file, index) in note.attachment" >
                  <div v-if="($Session && $Session.isInternalGroupMember) || !file.internal" class="md-layout md-gutter md-alignment-center" v-bind:key="index">
                    <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" >
                        <div v-show="file.name" class="attchment-card">
                            <div class="attchment-container">{{ file.description }} 
                                <div><a :href="file.s3Path" target="_blank">{{ file.name }}</a></div>
                                <!-- <div>{{ file.type }}</div> -->
                            </div>
                        </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <CommentList
            :currentItem="note"
            :userListItems="userListItems"
            :caseId="caseId"
            :serviceId="serviceId"
            :atNewComment="atNewComment"
          ></CommentList>
          <div class="_noteCard__body" v-if="note._case">
          	<span>Case: </span>
            <span class="_noteCard__author"><a :href="getHref('cases', note._case.id)" target="_self">{{note._case.subject}}</a></span>
          </div>
          <div v-if="showCommentBox()" class="form-container textarea-container">
            <div class="dynamicList-loading-comment-spinner" v-show="promisePending">
              <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
            </div>
            <md-checkbox v-show="$Session && $Session.isInternalGroupMember" v-model="internal">Internal</md-checkbox>
            <TinyMceEditor
              :isComment="true"
              :content="commentModel"
              :mentionArr="userListItems"
              :attachments="attachmentData"
              v-model="commentModel"
              @itemSelected="commentItemSelected"
              @success="onUploadSuccess"
            />
            <div>
              <md-card-actions md-alignment="left" v-if="!attachmentData.length">
                <md-button class="md-simple md-just-icon _attachFileBtn">
                  <i class="material-icons" v-on:click="onUpload()">attachment</i>
                </md-button>
                <span v-if="attachmentData == null">Browse or attach file here</span>
              </md-card-actions>
              <md-card-content v-if="attachmentData.length" class="attachment-area">
                <div class="md-layout">
                  <md-card-actions md-alignment="left">
                    <md-button class="md-simple md-just-icon _attachFileBtn">
                    <i class="material-icons" v-on:click="onUpload()">attachment</i>
                  </md-button>
                  </md-card-actions>
                  <div class="md-layout-item">
                    <div class="md-layout md-gutter">
                      <div class="md-layout-item md-large-size-25 md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(attachment, chunkIndex) in attachmentData" v-bind:key="chunkIndex">
                        <div v-show="attachment.file.name" class="attchment-card">
                          <div class="attchment-container">{{ attachment.file.name }} ({{ attachment.file.size | kb }} kb)
                            <button type="button" class="attachment-button" title="Remove" @click="removeFile(chunkIndex)" >x</button>
                          </div>
                          <!-- <md-checkbox 
                            class="attachment-area__checkbox" 
                            v-show="$Session && $Session.isInternalGroupMember"
                            v-model="isInternal"
                          >Internal</md-checkbox> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
              <md-card-actions md-alignment="right">
                <md-button class="md-sm md-success" :disabled="commentModel==''" @click="sendComment()">
                  <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">send</i> Comment
                </md-button>
                <md-button class="md-sm md-danger" @click="cancelComment(true)">
                  <i class="md-icon md-icon-font md-bottom-bar-icon md-theme-default">close</i> Cancel
                </md-button>
              </md-card-actions>
            </div>
          </div>
        </div>

        <!-- Upload Dialog -->
        <md-dialog :md-active.sync="isUploadDialogOpen" class="_attachmentsDialog">
          <md-dialog-title>Attachment</md-dialog-title>
          <md-dialog-content>
            <CommentAttachmentsForm
              :docTypes="docTypes"
              :model="attachmentData"
              @success="onUploadSuccess"
            />
          </md-dialog-content>
        </md-dialog>

        <md-dialog-alert
          :md-active.sync="dialog.status"
          :md-content="dialog.content"
          :md-confirm-text="dialog.confirmText"
          @md-closed="dialog.content = ''"
        />
        <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
          <span>{{ snackbarMsg }}</span>
        </md-snackbar>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { API, graphqlOperation, Storage } from "aws-amplify";
import * as mutations from "@/graphql/mutations";
import DeepLink from "./DeepLink";
import TinyMceEditor from "@/components/Editor/TinyMceEditor";
import CommentList from "@/components/DynamicForm/CommentList";
import CommentAttachmentsForm from '@/components/DynamicForm/Attachments/CommentAttachmentsForm';
import AttachmentMixin from '@/components/DynamicForm/Attachments/Mixins/AttachmentMixin';
import aws_exports from '@/aws-exports';
const { v4: uuidv4 } = require('uuid');

export default {
  mixins: [AttachmentMixin],
  components: {
    DeepLink,
    TinyMceEditor,
    CommentList,
    CommentAttachmentsForm
  },
  props: {
    caseId: {
      type: String,
      required: false
    },
    serviceId: {
      type: String,
      required: false,
    },
    note: {
      type: Object,
      required: true
    },
    atNoteEdit: {
      type: Function,
      required: true
    },
    userListItems: {
      type: Array,
      required: true,
      default: []
    },
    atNewComment: {
      type: Array
    }
  },
  data() {
    return {
      dialog: {
        status: false,
        content: "",
        confirmText: "Ok!"
      },
      // promisePending: false,
      items: [],
      commentItem: null,
      commentModel: "",
      buttonClicked: {
        comment: false
      },
      internal: false,
      atMentionsCommentList: [],
      atMentionsUserList: []
    };
  },
  watch: {},
  methods: {
    deleteNoteAlert() {
      Swal.fire({
        title: "Are you sure you want to delete {objectName}?".replace(
          "{objectName}",
          this.note.note.substr(0, 25).replace(/<[^>]+>/gm, "")
        ),
        text: `The change cannot be undone.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteNote(this.note);
        }
      });
    },
    async deleteNote(item) {
      await API.graphql(
        graphqlOperation(mutations["deleteNote"], { input: { id: item["id"] } })
      )
        .then(this.afterDeleteNote(item))
        .catch(error => {
          this.$c.log(this.list.pageTitle + " delete record error:", error);
        });
    },
    afterDeleteNote(item) {
      this.snackbarMsg = 'Note deleted successfully';
      this.isSnackbarOpen = true;
    },
    editNote() {
      this.atNoteEdit(this.note);
    },
    timediff(updatedDateTimeStamp) {
      let updatedDate = new Date(updatedDateTimeStamp);
      let now = new Date(),
        secondsPast = (now.getTime() - updatedDate.getTime()) / 1000;
      // let displayDate = updatedDate.toLocaleString('default', { month: 'long' }) + " " + updatedDate.getDate() + ", " + updatedDate.getFullYear() + ", " + updatedDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      let displayDate = this.$options.filters.DateFormat(updatedDate)

      if (secondsPast < 60) return " Just now " + displayDate;
      if (secondsPast < 3600)
        return parseInt(secondsPast / 60) + " minutes ago " + displayDate;
      if (secondsPast <= 86400)
        return parseInt(secondsPast / 3600) + " hour ago " + displayDate;
      if (secondsPast > 86400)
        return displayDate;
    },
    showCommentButton() {
      return (
        !this.buttonClicked.comment || this.commentItem.id !== this.note.id
      );
    },
    showCommentBox: function() {
      return this.buttonClicked.comment && this.commentItem.id === this.note.id;
    },
    comment() {
      this.buttonClicked.comment = true;
      this.commentItem = this.note;
      this.internal = this.note.internal;
    },
    cancelComment(isSuccess) {
      if (isSuccess) {
        this.attachmentData = null;
      }
      this.buttonClicked.comment = false;
      this.commentItem = null;
      this.commentModel = "";
      //clean the array
      this.atMentionsUserList.splice(0, this.atMentionsUserList.length);
    },
    async sendComment() {
      //this.placeHolder();
      this.promisePending = true;
      let inputCommentData = {
        internal: this.internal,
        commentNoteId: this.commentItem.id,
        commentUserId: this.$Session.userId
      };
      
      let error = null;
      const s3Key = `comments/${uuidv4()}`;
      const s3Response = await Storage
        .put(s3Key, this.commentModel, {
          bucket: aws_exports.aws_user_files_s3_bucket,
          region: aws_exports.aws_user_files_s3_bucket_region,
        })
        .catch(err => {
          error = err;
          console.log('Error uploading comment to S3', err)
        });
        
      if (error) {
        this.snackbarMsg = error.message || 'Something went wrong. Please try again.';
        this.isSnackbarOpen = true;
        this.promisePending = false;
        return;
      }
      
      inputCommentData.s3Url = s3Key;

      //get atMention user data
      this.getAtMentionUsers (this.commentModel);

      //add data for atMentions key
      if (this.atMentionsUserList && this.atMentionsUserList.length) {
        let atMentionsList = {
          items: this.atMentionsUserList
        };
        inputCommentData.atMentions = JSON.stringify(atMentionsList);
      }
      
      /**
       * ATLAS-877 - Add Updatedby to all Models in the Schema
       * @see https://zeamster.atlassian.net/browse/ATLAS-877
       */
      inputCommentData['commentUpdatedById'] = this.$reduce(this, '$Session.userId');

      let gqlRequest = graphqlOperation(mutations["createComment"], {
        input: inputCommentData
      });
      this.$c.log("gqlRequest", gqlRequest);

      const result = await API.graphql(gqlRequest)
        .then(async result => {
          this.$c.log("***** new comment added ****** ",result);
          
          const newCommentId = result.data.createComment.id
          this.attachments = this.attachmentData
          const commentUpdatedAt = result.data.createComment.updatedAt

          const relations = [
            { fromModelType: 'Comment', relationCommentId: newCommentId },
          ]
          
          if (this.caseId) {
            relations.push({ fromModelType: 'Case', relationCaseId: this.caseId });
          } else {
            // extract case id from note if case id is not passed as props
            const noteCaseId = this.$reduce(this, 'note._case.id');
            if (noteCaseId) {
              relations.push({ fromModelType: 'Case', relationCaseId: noteCaseId });
            }
          }
          
          if (this.serviceId) {
            relations.push({ fromModelType: 'Service', relationServiceId: this.serviceId });
          }
          
          await this.add(relations)
          await this.UpdateNoteUpdatedAt(this.commentItem.id, commentUpdatedAt)
          this.commentMentionList = [];
          this.cancelComment(true);
          this.promisePending = false
        })
        .catch(error => {
          this.$c.log("error ", error);
          this.dialog.status = true;
          this.dialog.content = error.errors[0].message;
          this.attachments = []
          this.promisePending = false;
        });
    },
    /**
     * ATLAS-378 Case Comment atMentions
     * Get atMention user data
     */
    commentItemSelected (item) {
      this.atMentionsCommentList.push(item);
    },
    getAtMentionUsers (commentData) {
      this.atMentionsCommentList.forEach(el => {
        if(commentData.includes(el.name)) {
          if(this.atMentionsUserList.indexOf(el.id) == -1) {
            this.atMentionsUserList.push(el.id);
          }
        }
      });
    },
    getHref(path,id) {
      return '#' + '/'+ path + '/' + id;
    },
    async UpdateNoteUpdatedAt(noteId, updatedAt) {
      let updateInput = {
        id: noteId,
        updatedAt: updatedAt
      }
      let gqlRequest = graphqlOperation(mutations["updateNote"], {
        input: updateInput
      });
      this.$c.log("gqlRequest for note update ", gqlRequest);

      const result = await API.graphql(gqlRequest)
        .then(async result => {
          this.$c.log("***** note updated ******* ",result);
          this.promisePending = false
        })
        .catch(error => {
          this.$c.log("error", error);
        });
    },
    removeFile(fileIndex){
      this.attachmentData.splice(fileIndex, 1)
    },
  }
};
</script>

<style lang="scss">
._feed_item__note .note ._copy {
  z-index: 1;
  position: absolute;
  top: 10px;
  right: 110px;
  margin-top: 3px;
  color: rgba(0, 0, 0, 0.54);
}

.note span._copy._fixCopy {
  right: 83px !important;
}

._feed_item__note {
  .pd0 {
    padding:0px
  }

  .md-layout-item-attachment {
    width: max-content !important;
  }

  .md-layout-item-padding {
    padding: 0 10px !important;
  }
}

</style>
